export default {
    Get: {
        PUBLISH_KORFINE: 'getPublishKorfine',
    },
    Set: {
        KORFINE_REQUEST_INFO: 'setKorfineRequestInfo',
        KORFINE_ASSIGN_VALUE: 'assignKorfineValue',
        CONTRACT_ASSIGN_VALUE: 'assignContractValue',
        CONTRACT_RESET: 'resetContractValue',
        AGREEMENT_ASSIGNVALUE: 'assignAgreementValue',
        AGREEMENT_RESET: 'resetAgreementValue',
        OWNER_ASSIGNVALUE: 'assignOwnerValue',
        OWNER_RESET: 'resetOwnerValue',
        TENANT_ASSIGNVALUE: 'assignTenantValue',
        TENANT_RESET: 'resetTenantValue',
        ESTATE_ASSIGNVALUE: 'assignEstateValue',
        ESTATE_RESET: 'resetEstateValue',
        OWNER_PERSON_ASSIGNVALUE: 'assignOwnerPersonValue',
        OWNER_PARTNER_ASSIGNVALUE: 'assignOwnerPartnerValue',
        TENANT_PERSON_ASSIGNVALUE: 'assignTenantPersonValue',
        TENANT_PARTNER_ASSIGNVALUE: 'assignTenantPartnerValue',
        KORFINE_RESET: 'korfineReset',
    }
}